export default __webpack_public_path__ + "static/media/cover.979b295a.svg";